import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditHealthInsurances = () => {
  return (
    <Edit
      title="Редактиране на здравна осигуровка"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm isCreating={false}/>
      </SimpleForm>
    </Edit>
  );
};

export default EditHealthInsurances;
